import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";

export const GET_MYPEOPLE_GRID = NAME + "/GET_MYPEOPLE_GRID";
export const GET_MYPEOPLE_GRID_REJECTED = NAME + "/GET_MYPEOPLE_GRID_REJECTED";
export const GET_MYPEOPLE_GRID_FULFILLED = NAME + "/GET_MYPEOPLE_GRID_FULFILLED";

export const GET_BASIC_ELEMENTS = NAME + "/GET_BASIC_ELEMENTS";
export const GET_BASIC_ELEMENTS_FULFILLED = NAME + "/GET_BASIC_ELEMENTS_FULFILLED";
export const GET_BASIC_ELEMENTS_REJECTED = NAME + "/GET_BASIC_ELEMENTS_REJECTED";

export const DELETE = NAME + "/DELETE";
export const DELETE_REJECTED = NAME + "/DELETE_REJECTED";
export const DELETE_FULFILLED = NAME + "/DELETE_FULFILLED";

export const CREATE = NAME + "/CREATE";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";

export const MODIFY = NAME + "/MODIFY";
export const MODIFY_REJECTED = NAME + "/MODIFY_REJECTED";
export const MODIFY_FULFILLED = NAME + "/MODIFY_FULFILLED";

export const DOWNLOAD = NAME + "/DOWNLOAD";
export const DOWNLOAD_FULFILLED = NAME + "/DOWNLOAD_FULFILLED";
export const DOWNLOAD_REJECTED = NAME + "/DOWNLOAD_REJECTED";

export const DUPLICATE = NAME + "/DUPLICATE";
export const DUPLICATE_FULFILLED = NAME + "/DUPLICATE_FULFILLED";
export const DUPLICATE_REJECTED = NAME + "/DUPLICATE_REJECTED";

export const ADD_CONCEPT = NAME + "/ADD_CONCEPT";
export const ADD_CONCEPT_REJECTED = NAME + "/ADD_CONCEPT_REJECTED";
export const ADD_CONCEPT_FULFILLED = NAME + "/ADD_CONCEPT_FULFILLED";

export const DUPLICATE_CONCEPT = NAME + "/DUPLICATE_CONCEPT";
export const DUPLICATE_CONCEPT_REJECTED = NAME + "/DUPLICATE_CONCEPT_REJECTED";
export const DUPLICATE_CONCEPT_FULFILLED = NAME + "/DUPLICATE_CONCEPT_FULFILLED";